"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Bubble = _interopRequireWildcard(require("../../../Bubble/Bubble"));
var _styles = require("../../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var QuestionIcon = function QuestionIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "8",
    cy: "8",
    r: "7.5",
    stroke: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff",
    d: "M7.665 9.78l.732-.312c-.204-.156-.324-.396-.324-.588 0-1.176 2.327-1.332 2.327-3.144 0-1.032-.887-1.86-2.351-1.86-1.14 0-2.028.48-2.604 1.224l.6.648c.444-.588 1.008-.984 1.908-.984.948 0 1.416.516 1.416 1.116 0 1.272-2.172 1.404-2.172 2.928 0 .36.144.696.468.972zm.252 2.34c.36 0 .66-.3.66-.66 0-.36-.3-.66-.66-.66-.36 0-.66.3-.66.66 0 .36.3.66.66.66z"
  }));
};
QuestionIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
};
var MAP_STYLES = new Map([[1, 'background: linear-gradient(90deg, #B1ABA0 0%, #BC967D 100%);'],
// GOLD-BROWN
[2, 'background: linear-gradient(90deg, #298BF1 0%, #A125CD 100%);'],
// BLUE-PURPLE
[3, 'background: linear-gradient(90deg, #F27929 0%, #E53981 100%);'] // RED-PINK
]);
var HotelCardHeaderLabel = function HotelCardHeaderLabel(_ref) {
  var id = _ref.id,
    iconPath = _ref.icon_path,
    title = _ref.title,
    description = _ref.description,
    style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement(StyledBubble, {
    text: description
  }, /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    key: id,
    styles: style
  }, iconPath && /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    iconPath: iconPath
  }), /*#__PURE__*/_react["default"].createElement("span", null, title), /*#__PURE__*/_react["default"].createElement(Icon, null, /*#__PURE__*/_react["default"].createElement(QuestionIcon, null))));
};
var StyledBubble = (0, _styledComponents["default"])(_Bubble["default"]).withConfig({
  displayName: "HotelCardHeaderLabel__StyledBubble",
  componentId: "sc-1be1825-0"
})(["", " ", "{width:100%;}"], _styles.fixScroll, _Bubble.InnerWrapper);
var StyledLabel = exports.StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardHeaderLabel__StyledLabel",
  componentId: "sc-1be1825-1"
})(["display:flex;justify-content:center;align-items:center;color:#ffffff;border-top-left-radius:4px;border-top-right-radius:4px;height:24px;font-size:12px;line-height:14px;text-transform:uppercase;letter-spacing:0.857px;", ""], function (_ref2) {
  var _ref2$styles = _ref2.styles,
    styles = _ref2$styles === void 0 ? 1 : _ref2$styles;
  return MAP_STYLES.get(styles);
});
var StyledIcon = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardHeaderLabel__StyledIcon",
  componentId: "sc-1be1825-2"
})(["height:22px;width:22px;margin-right:7px;background-size:contain;background-position:center;background-repeat:no-repeat;flex-shrink:0;background-image:url('", "');"], function (_ref3) {
  var iconPath = _ref3.iconPath;
  return iconPath;
});
var Icon = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardHeaderLabel__Icon",
  componentId: "sc-1be1825-3"
})(["margin-left:4px;cursor:pointer;width:16px;height:16px;"]);
var _default = exports["default"] = HotelCardHeaderLabel;